"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Content = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_text_1 = require("@hopin-team/ui-text");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.Content = (0, styled_components_1.default)(ui_text_1.Text).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['isInverse'].includes(prop);
  }
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  z-index: 1;\n  background: ", ";\n  box-shadow: ", ";\n  border-radius: ", ";\n  text-align: center;\n  width: 100%;\n  white-space: normal;\n"], ["\n  position: relative;\n  z-index: 1;\n  background: ", ";\n  box-shadow: ", ";\n  border-radius: ", ";\n  text-align: center;\n  width: 100%;\n  white-space: normal;\n"])), function (_a) {
  var theme = _a.theme,
      isInverse = _a.isInverse;
  return isInverse ? (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme) : (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.DARK', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('PLANE.SHADOWS.MEDIUM', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS.MEDIUM', theme);
});
var templateObject_1;